import { IFilterButtonGroupItemsWithBtnText } from '@/bundles/GroupFilters/interfaces/inputs/IFilterButtonGroupItems';
import { AllExcludeOnlyEnum, AllExcludeOnlyLabels } from '@/bundles/GroupFilters/enums/AllExcludeOnlyEnum';

export const FilterConfidentialItems: IFilterButtonGroupItemsWithBtnText[] = [
  {
    text: AllExcludeOnlyLabels[AllExcludeOnlyEnum.only],
    value: AllExcludeOnlyEnum.only,
    btnText: `Confidential \n Only`,
  },
  {
    text: AllExcludeOnlyLabels[AllExcludeOnlyEnum.all],
    value: AllExcludeOnlyEnum.all,
  },
  {
    text: AllExcludeOnlyLabels[AllExcludeOnlyEnum.exclude],
    value: AllExcludeOnlyEnum.exclude,
    btnText: `Exclude \n Confidential`,
  }
];
